<div class="mm-toasts" aria-live="polite" aria-atomic="false">
  <div class="mm-toast" *ngFor="let t of (toasts.toasts$ | async)" [ngClass]="'mm-toast-' + t.type" role="alert">
    <i class="fa mm-toast-icon" [ngClass]="icon(t.type)" aria-hidden="true"></i>
    <span class="mm-toast-msg">{{ t.message }}</span>
    <button type="button" class="mm-toast-x" (click)="toasts.dismiss(t.id)" aria-label="Dismiss">
      <i class="fa fa-times" aria-hidden="true"></i>
    </button>
  </div>
</div>
